module.exports = __webpack_public_path__ + "img/3.ca50fffa.png";